const validators = {
    phoneNumber: (value) => {
        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        return value === "" || phoneRegex.test(value);
    }
};

export default validators;
